import analytics from '@banking/ui/workflows/utils/analytics';
import { Action } from '@banking/ui/workflows/bank-accounts/index';
import { filter, map } from 'rxjs/operators';
import { ActionType as AllLocationsActionType } from '@banking/ui/workflows/bank-accounts/all-locations';
import { ActionType as CancelVerificationActionType } from '@banking/ui/workflows/bank-accounts/cancel-verification';
import { ActionType as ChangeBankAccountActionType, Screen as ChangeBankAccountScreen } from '@banking/ui/workflows/bank-accounts/change-bank-account';
import assert from '@banking/ui/utils/assert';
export let EventLogging;
(function (_EventLogging) {
  let Action = /*#__PURE__*/function (Action) {
    Action["Click"] = "Click";
    Action["View"] = "View";
    return Action;
  }({});
  _EventLogging.Action = Action;
  let Applet = /*#__PURE__*/function (Applet) {
    Applet["Settings"] = "Settings";
    return Applet;
  }({});
  _EventLogging.Applet = Applet;
  let Feature = /*#__PURE__*/function (Feature) {
    Feature["BankAccounts"] = "Bank Accounts";
    Feature["LocationBankAccount"] = "Location Bank Account";
    return Feature;
  }({});
  _EventLogging.Feature = Feature;
  let Page = /*#__PURE__*/function (Page) {
    Page["Overview"] = "Overview";
    return Page;
  }({});
  _EventLogging.Page = Page;
  let SubFeature = /*#__PURE__*/function (SubFeature) {
    SubFeature["AddBankAccount"] = "Add Bank Account";
    SubFeature["CancelVerification"] = "Cancel Verification";
    SubFeature["SwapBankAccount"] = "Swap Bank Account";
    return SubFeature;
  }({});
  _EventLogging.SubFeature = SubFeature;
  let Target = /*#__PURE__*/function (Target) {
    Target["AddExternalBankAccount"] = "Add External Bank Account";
    Target["BankAccountLinked"] = "Bank Account Linked";
    Target["Cancel"] = "Cancel";
    Target["CancelEmail"] = "Cancel Email";
    Target["CancelVerification"] = "Cancel Verification";
    Target["ConfirmCancel"] = "Confirm Cancel";
    Target["ContinueVerification"] = "Continue Verification";
    Target["Failed"] = "Failed";
    Target["ResendEmail"] = "Resend Email";
    Target["SelectNewBankAccount"] = "Select New Bank Account";
    Target["UpdateBankAccount"] = "Update Bank Account";
    return Target;
  }({});
  _EventLogging.Target = Target;
  let CDP;
  (function (_CDP) {
    const eventString = (action, feature) => `${action} ${feature}`;
    const event = _CDP.event = args => {
      return [eventString(args.action, Feature.LocationBankAccount), {
        ...args,
        applet: Applet.Settings,
        feature: Feature.LocationBankAccount
      }];
    };
  })(CDP || (CDP = _EventLogging.CDP || (_EventLogging.CDP = {})));
})(EventLogging || (EventLogging = {})); // Sub Feature - Swap Bank Account
const selectNewBankAccountClick = updates => updates.pipe(filter(([_, action]) => action.type === AllLocationsActionType.UserClickChangeBankAccount), map(([[_before, _after], action]) => {
  assert('unitToken' in action);
  assert(typeof action.unitToken === 'string');
  return EventLogging.CDP.event({
    action: EventLogging.Action.Click,
    subFeature: EventLogging.SubFeature.SwapBankAccount,
    unitToken: action.unitToken,
    target: EventLogging.Target.SelectNewBankAccount
  });
}));
const updateBankAccountClick = updates => updates.pipe(filter(([_, action]) => action.type === ChangeBankAccountActionType.UserClickUpdateBankAccount), map(([[_before, after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  subFeature: EventLogging.SubFeature.SwapBankAccount,
  unitToken: after.changeBankAccountModal.unitToken,
  target: EventLogging.Target.UpdateBankAccount
})));
const cancelClick = updates => updates.pipe(filter(([[before, after], action]) => action.type === ChangeBankAccountActionType.ToggleChangeBankAccountModal && before.changeBankAccountModal.screen === ChangeBankAccountScreen.CONFIRM && before.changeBankAccountModal.isModalOpen && !after.changeBankAccountModal.isModalOpen), map(([[before, _after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  subFeature: EventLogging.SubFeature.SwapBankAccount,
  unitToken: before.changeBankAccountModal.unitToken,
  target: EventLogging.Target.Cancel
})));
const bankAccountLinkedView = updates => updates.pipe(filter(([[before, after], action]) => action.type === ChangeBankAccountActionType.IncrementScreen && before.changeBankAccountModal.screen !== ChangeBankAccountScreen.SUCCESS && after.changeBankAccountModal.screen === ChangeBankAccountScreen.SUCCESS), map(([[before, _after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  subFeature: EventLogging.SubFeature.SwapBankAccount,
  unitToken: before.changeBankAccountModal.unitToken,
  target: EventLogging.Target.BankAccountLinked
})));
const failedView = updates => updates.pipe(filter(([[before, after], action]) => action.type === ChangeBankAccountActionType.IncrementScreen && before.changeBankAccountModal.screen !== ChangeBankAccountScreen.ERROR && after.changeBankAccountModal.screen === ChangeBankAccountScreen.ERROR), map(([[before, _after], _action]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  subFeature: EventLogging.SubFeature.SwapBankAccount,
  unitToken: before.changeBankAccountModal.unitToken,
  target: EventLogging.Target.Failed
})));

// Sub Feature - Add Bank Account
const addExternalBankAccountClick = updates => updates.pipe(filter(([_, action]) => action.type === AllLocationsActionType.UserClickAddExternalBankAccount), map(([[_before, _after], action]) => {
  assert('unitToken' in action);
  assert(typeof action.unitToken === 'string');
  return EventLogging.CDP.event({
    action: EventLogging.Action.Click,
    subFeature: EventLogging.SubFeature.AddBankAccount,
    unitToken: action.unitToken,
    target: EventLogging.Target.AddExternalBankAccount
  });
}));

// TODO @jmah: Add these events after the new link bank account flow is created
// confirmPasswordClick
// verifyBankAccountInfoClick
// checkEmailView
// bankAccountBeingVerifiedView

// Sub Feature - none
const resendEmailClick = updates => updates.pipe(filter(([_, action]) => action.type === AllLocationsActionType.UserClickResendEmail), map(([[_before, _after], _action]) => {
  return EventLogging.CDP.event({
    action: EventLogging.Action.Click,
    target: EventLogging.Target.ResendEmail
  });
}));

// Sub Feature - Cancel Verification
const cancelVerificationClick = updates => updates.pipe(filter(([_, action]) => action.type === AllLocationsActionType.UserClickCancelVerification), map(([[_before, _after], action]) => {
  assert('unitToken' in action);
  assert(typeof action.unitToken === 'string');
  return EventLogging.CDP.event({
    action: EventLogging.Action.Click,
    subFeature: EventLogging.SubFeature.CancelVerification,
    target: EventLogging.Target.CancelVerification,
    unitToken: action.unitToken
  });
}));
const confirmCancelClick = updates => updates.pipe(filter(([_, action]) => action.type === CancelVerificationActionType.UserClickCancelBankVerification), map(([[before, _after], _action]) => {
  return EventLogging.CDP.event({
    action: EventLogging.Action.Click,
    subFeature: EventLogging.SubFeature.CancelVerification,
    target: EventLogging.Target.ConfirmCancel,
    unitToken: before.cancelVerificationModal.unitToken
  });
}));
const continueVerificationClick = updates => updates.pipe(filter(([_, action]) => action.type === CancelVerificationActionType.UserClickContinueBankVerification), map(([[before, _after], _action]) => {
  return EventLogging.CDP.event({
    action: EventLogging.Action.Click,
    subFeature: EventLogging.SubFeature.CancelVerification,
    target: EventLogging.Target.ContinueVerification,
    unitToken: before.cancelVerificationModal.unitToken
  });
}));
export default analytics([addExternalBankAccountClick, bankAccountLinkedView, cancelClick, cancelVerificationClick, confirmCancelClick, continueVerificationClick, failedView, resendEmailClick, selectNewBankAccountClick, updateBankAccountClick]);